<template>
  <div>
    <b-form :class="formClass">
      <div v-if="inlineLayout" class="wrap d-flex align-items-center justify-content-start">
        <label :for="id" class="predictive-label">Allow</label>
        <div class="range-wrapper">
          <div class="marks">
            <div v-for="n in 20" :key="n"></div>
          </div>
          <b-form-input
              class="predictive-range"
              :id="id"
              v-model.number="localValue"
              type="range"
              min="5"
              max="100"
              step="5"
          ></b-form-input>
          <div class="counts"><span>5</span><span>25</span><span>50</span><span>75</span><span>100</span></div>
        </div>
        <div class="predictive-value">{{ localValue }}</div>
        <div class="predictive-percent">{{ percent }}</div>
        <span class="page-views">pageviews</span>
      </div>
      <template v-else>
        <div class="pred-row d-flex align-items-center justify-content-start predictive-view-taxonomies">
          <label :for="id" class="predictive-label">Allow</label>
          <div class="predictive-value">{{ localValue }}</div>
          <div class="predictive-percent">{{ percent }}</div>
          <span class="page-views">pageviews</span>
        </div>
        <div class="pred-row">
          <div class="range-wrapper">
            <div class="marks">
              <div v-for="n in 20" :key="n"></div>
            </div>
            <b-form-input
                class="predictive-range"
                :id="id"
                v-model.number="localValue"
                type="range"
                min="5"
                max="100"
                step="5"
            ></b-form-input>
            <div class="counts"><span>5</span><span>25</span><span>50</span><span>75</span><span>100</span></div>
          </div>
        </div>
      </template>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "PredictiveRange",
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    id: {
      type: String,
      default: "range-1",
    },
    inlineLayout: {
      type: Boolean,
      default: true,
    },
    formClass: {
      type: String,
      default: "range-form",
    },
  },
  data() {
    return {
      rangeValue: this.value,
      percent: "%",
    };
  },
  computed: {
    localValue: {
      get() {
        return Number(this.value);
      },
      set(value) {
        this.$emit("input", Number(value));
      },
    },
  },
};
</script>

<style scoped>
.predictive-label {
  margin-bottom: 0;
  margin-right: 16px;
}
.predictive-value {
  display: block;
  width: auto;
  min-width: 50px;
  white-space: nowrap;
  height: 40px;
  padding: 6px 12px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 27px;
  color: #5c6873;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e4e7ea;
  border-right: none;
  border-radius: 0.25rem 0 0 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.predictive-percent {
  display: block;
  width: auto;
  min-width: 39px;
  height: 40px;
  padding: 6px 12px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 27px;
  color: #5c6873;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e4e7ea;
  border-radius: 0 0.25rem 0.25rem 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.range-wrapper {
  width: 100%;
  height: 40px;
  padding: 0;
  margin-right: 16px;
  position: relative;
  top: -4px;
}
.range-wrapper .counts {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.range-wrapper .counts span {
  display: block;
  color: #73818f;
}
.range-wrapper .counts span:nth-child(2) {
  margin-left: -2%;
}
.range-wrapper .marks {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  top: 17px;
}
.range-wrapper .marks div {
  width: 1px;
  height: 12px;
  background-color: #73818f;
}
.range-wrapper .marks div:nth-child(even) {
  height: 10px;
}
@media only screen and (max-width: 600px) {
  .range-form .wrap,
  .range-form-taxonomies {
    flex-wrap: wrap;
  }
  .range-wrapper {
    margin-bottom: 20px;
  }
}
.predictive-range::-webkit-slider-runnable-track {
  background-color: #73818f;
  height: 2px;
}
.predictive-range::-moz-range-track {
  background-color: #73818f;
  height: 2px;
}
.predictive-range::-webkit-slider-thumb {
  position: relative;
  top: -3px;
}
.predictive-range::-moz-range-thumb {
  position: relative;
  top: -3px;
}
.predictive-percent {
  margin-right: 16px;
}
.predictive-view-taxonomies > div {
  width: 100%;
}
.predictive-view-taxonomies > div div {
  width: auto;
}
</style>